<template>
  <div>
    <div class="form-group" v-if="prefijo == enumeraciones.etiquetasDeHTML.Select">
      <select v-bind:id="idDelInput" v-model="idDelModelo" class="form-control" @change="cambiarDatos($event)">
        <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id" :value="tipo.Id">{{tipo.Nombre}} un juzgado</option>
        <option v-else-if="tipo.Id == enumeraciones.tiposDeSelect.Todos.Id && tipo.Nombre == enumeraciones.tiposDeSelect.Todos.Nombre" :value="tipo.Id">{{enumeraciones.tiposDeSelect.Todos.Nombre}} los juzgados</option>
        <option v-else-if="tipo.Id == enumeraciones.tiposDeSelect.Todas.Id && tipo.Nombre == enumeraciones.tiposDeSelect.Todas.Nombre" :value="tipo.Id">{{enumeraciones.tiposDeSelect.Todas.Nombre}} las áreas</option>
        <option v-for="Area in Areas" :key="Area.AreaId" :value="Area.AreaId">{{Area.Nombre}}</option>
      </select>
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import comun from '@/../static/js/comun'
  import api from '@/../static/js/api'
  import axios from 'axios'

  export default {
    data() {
      return {
        enumeraciones,
        comun,
        Areas: [],
        idDelModelo: null        
      }
    },
    props: {
      prefijo: Number,
      tipo: {
        Id: Number,
        Nombre: String
      },
      idDelInput: String,
      valorDefinido: Number,
      parametros: Object
    },
    mounted() {
      //this.params = this.parametros
      if(this.valorDefinido == undefined || this.valorDefinido == null)
        this.idDelModelo = this.tipo.Id;
      else
        this.idDelModelo = this.valorDefinido;
      
      const params = {
        llave: this.idDelInput,
        valor: this.idDelModelo
      }
      //this.$store.dispatch("A_Archivo_Catalogo_Establecer001Area", params);
    },
    methods: {
      cargaCatalogoDeAreas: function() {
        if(this.parametros == null || this.parametros == undefined)
          this.parametros = {}
        this.parametros.EsPrueba = this.enumeraciones.EsPrueba

        axios.post(api.conexion + api.PJ.catalogos.C001Areas, this.parametros)
          .then(respuesta => {
            if (respuesta.data.SiHayError) {
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {
              
              var areasObtenidas = respuesta.data.Areas;
              var areasConMaterias= [];
              $.each(areasObtenidas, function(indice, area){
                areasConMaterias.push ({
                  "AreaId": area.AreaId,
                  "Nombre" : area.Nombre,
                  "MateriaId": area.Materias.length >0 ? area.Materias[0].MateriaId : 20,
                  "Materias": area.Materias
                })
                areasConMaterias.sort((x,y)=>(x.MateriaId - y.MateriaId || x.AreaId-y.AreaId))
              });
              this.Areas = areasConMaterias;//.sort((x,y)=>(x.MateriaId>y.MateriaId ? 1 : -1) && (x.AreaId>y.AreaId? 1:-1))
             
              if (this.parametros.filtros != undefined && this.parametros.filtros != null) {
                this.Areas = respuesta.data.Areas.filter(cond => this.parametros.filtros.some(area => area == cond.AreaId));
              }
            }
          })
          .catch(excepcion => {
            console.log(excepcion);
            comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
          });
      },
      cambiarDatos(evento) {
        this.idDelModelo = evento.target.value;
        const params = {
          llave: this.idDelInput,
          valor: evento.target.value
        }
        
        this.$store.dispatch("A_ArchivoJudicial_Catalogo_Establecer001Area", params);
        this.$emit("valorParaElPadre", [evento, this.Areas[evento.target.selectedIndex -1]]);        
      }
    },
    created() {
      this.cargaCatalogoDeAreas();
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/ArchivoJudicial/Comun/Catalogos/001Areas.vue